<template>
  <v-card flat>
    <v-card-text class="p0">
      <div class="dropzone" type="file" @dragover.prevent.self="onOver" @drop.prevent.stop.capture="onDrop">
        <div class="file-preview">
          <div v-for="(file, index) in files" :key="index" @click="deleteFile(file.name)">
            <v-chip close>
              {{ file.name }}
            </v-chip>
          </div>
        </div>
      </div>
      <input ref="file" :multiple="multiple" type="file" @change="addFiles" />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    reset: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      files: []
    };
  },
  watch: {
    reset(val) {
      // reset form if reset value changes
      if (val) {
        this.$refs.file.value = '';
        this.files = [];
      }
    }
  },
  methods: {
    onOver(e) {
      e.target.style.background = 'var(--blue)';
      e.target.style.color = 'white';
    },
    onDrop(e) {
      e.target.style.background = 'var(--light-form-bg)';
      e.target.style.color = 'var(--dark)';
      Array.from(e.dataTransfer.files).forEach(f => {
        //if (e.dataTransfer.files[i].type === 'application/pdf')
        this.files.push(f);
      });
      // reset
      if (!this.multiple) {
        this.$refs.file.value = '';
      }
      this.change();
    },
    addFiles(e) {
      Array.from(e.target.files).forEach(f => {
        this.files.push(f);
      });
      this.change();
    },
    deleteFile(filename) {
      if (!this.multiple) {
        this.files = [];
        this.change();
        return;
      }
      let index = this.files.findIndex(v => v.name === filename);
      if (index !== -1) {
        this.files.splice(index, 1);
      }
      this.change();
    },
    change() {
      if (!this.multiple) {
        // single upload
        this.files = this.files.length ? [this.files[this.files.length - 1]] : [];
      }
      this.$emit('change', this.files);
    }
  }
};
</script>
